import { HttpClient, HttpErrorResponse, HttpHeaders, HttpResponse } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { LocalService } from '@core/services/local.service';
import { environment } from '@env/environment';
import { BehaviorSubject, Observable, throwError } from 'rxjs';
import { map } from 'rxjs';
@Injectable({
  providedIn: 'root'
})
/**
 *
 *
 * @export
 * @class HttpService
 */
export class HttpService {
  overrideUrl = true;
  errorData!: HttpErrorResponse;
  baseUrl = '';
  public headers = new HttpHeaders()
    .set('Accept', 'application/json')
    .set('Content-Type', 'application/json')
    .set('role', 'role=CP_PUBLIC');

  public showSpinner: BehaviorSubject<boolean> = new BehaviorSubject<boolean>(false);
  public outsideShowSpinner: BehaviorSubject<boolean> = new BehaviorSubject<boolean>(false);
  url1: string;
  url: string;
  constructor(private readonly http: HttpClient) {
    /* url from config file or environments */
    this.url = environment.apiHost;
    this.url1 = '';
  }

  /**
   * Gets data.
   * @param {string} apiRoute
   * @return {*}  {Observable<TResponse>}
   * @memberof HttpService
   */
  get<TResponse = Object>(apiRoute: string): Observable<TResponse> {
    return this.http.get<TResponse>(`${this.url + apiRoute}`, {
      headers: this.getHttpHeaders(),
      withCredentials: true
    });
  }

  /**
   * Posts data.
   * @param {string} apiRoute
   * @param {TRequest} body
   * @return {*}  {Observable<TResponse>}
   * @memberof HttpService
   */
  post<TResponse, TRequest = unknown>(apiRoute: string, body: TRequest): Observable<TResponse> {
    return this.http.post<TResponse>(`${this.url + apiRoute}`, body, {
      headers: this.getHttpHeaders(),
      withCredentials: true
    });
  }

  /**
   * Puts data.
   * @param {string} apiRoute
   * @param {TRequest} body
   * @return {*}  {Observable<TResponse>}
   * @memberof HttpService
   */
  put<TResponse, TRequest = unknown>(apiRoute: string, body: TRequest): Observable<TResponse> {
    return this.http.put<TResponse>(`${this.url + apiRoute}`, body, {
      headers: this.getHttpHeaders(),
      withCredentials: true
    });
  }

  /**
   * Patches data.
   * @param {string} apiRoute
   * @param {TRequest} [body]
   * @return {*}  {Observable<TResponse>}
   * @memberof HttpService
   */
  patch<TResponse, TRequest = unknown>(apiRoute: string, body?: TRequest): Observable<TResponse> {
    return this.http.patch<TResponse>(`${this.url + apiRoute}`, body, {
      headers: this.getHttpHeaders(),
      withCredentials: true
    });
  }

  /**
   * Deletes data.
   * @param {string} apiRoute
   * @param {TRequest} [body]
   * @return {*}  {Observable<TResponse>}
   * @memberof HttpService
   */
  delete<TResponse, TRequest = unknown>(apiRoute: string, body?: TRequest): Observable<TResponse> {
    const options: {
      headers: HttpHeaders;
      withCredentials: boolean;
      body?: TRequest;
    } = {
      headers: this.getHttpHeaders(),
      withCredentials: true
    };
    if (body) {
      options.body = body;
    }
    return this.http.delete<TResponse>(`${this.url + apiRoute}`, options);
  }

  /**
   * Gets HTTP headers.
   * @return {*}  {HttpHeaders}
   * @memberof HttpService
   */
  getHttpHeaders(): HttpHeaders {
    return this.headers;
  }

  /**
   * Gets auth access key.
   * @param {string} apiRoute
   * @param {TRequest} body
   * @return {*}  {Observable<TResponse>}
   * @memberof HttpService
   */
  getAuthAccessKey<TResponse, TRequest = unknown>(apiRoute: string, body: TRequest): Observable<TResponse> {
    return this.http.post<TResponse>(`${this.url + apiRoute}`, body, {
      headers: this.headers,
      withCredentials: true
    });
  }

  /**
   * Gets attachment HTTP headers.
   * @param {string} contentType
   * @return {*}  {HttpHeaders}
   * @memberof HttpService
   */
  getAttachmentHttpHeaders(contentType: string): HttpHeaders {
    return this.headers.set('Content-Type', contentType).set('x-ms-blob-type', 'BlockBlob');
  }

  /**
   * Puts upload.
   * @param {string} apiRoute
   * @param {TRequest} body
   * @param {string} contentType
   * @return {*}  {Observable<TResponse>}
   * @memberof HttpService
   */
  putUpload<TResponse, TRequest = unknown | any>(apiRoute: string, body: TRequest, contentType: string): Observable<TResponse> {
    return this.http.put<TResponse>(`${apiRoute}`, body, {
      headers: this.getAttachmentHttpHeaders(contentType)
    });
  }

  /**
   * Puts upload2.
   * @param {string} apiRoute
   * @param {TRequest} body
   * @param {string} contentType
   * @return {*}  {Observable<HttpResponse<TResponse>>}
   * @memberof HttpService
   */
  putupload2<TResponse, TRequest = unknown>(
    apiRoute: string,
    body: TRequest,
    contentType: string
  ): Observable<HttpResponse<TResponse>> {
    return this.http
      .put<TResponse>(`${this.url1 + apiRoute}`, body, {
        headers: this.getAttachmentHttpHeaders(contentType),
        observe: 'response'
      })
      .pipe(
        map(data => data)
      );
  }
  getAutosuggest<TResponse>(url: string): Observable<TResponse> {
    return this.http.get<TResponse>(`${url}`);
  }
  /**
   *
   * @param {string} apiRoute
   * @return {*}  {void}
   * @memberof HttpService
   */
  getFormDownloaded(apiRoute: string): void {
    // This function will download the stream file from the API service.
    // No HTTP required for this stream. So used Window.location.href to download the file
    window.location.href = `${this.url + apiRoute}`;
  }
  /* common http service(optional) */
  /**
   * Handles errors.
   * @param {HttpErrorResponse} error
   * @return {*}  {Observable<never>}
   * @memberof HttpService
   */
  handleError(error: HttpErrorResponse): Observable<never> {
    this.errorData = error;
    let errorMessage = '';
    if (error.error instanceof ErrorEvent) {
      /* Client-side errors */
      errorMessage = `Error: ${error.error.message}`;
    } else {
      /* Server-side errors */
      errorMessage = `Error Code: ${error.status}\nMessage: ${error?.error?.message ? error?.error?.message : error.message
        }`;
    }
    return throwError(() => errorMessage);
  }

  /**
   * Gets attachment.
   * @param {string} apiRoute
   * @param {TRequest} body
   * @param {Record<string, unknown>} [options]
   * @return {*}  {Observable<TResponse>}
   * @memberof HttpService
   */
  getAttachment<TResponse, TRequest = unknown>(
    apiRoute: string,
    body: TRequest,
    options: Record<string, unknown> = {}
  ): Observable<TResponse> {
    return this.http.post<TResponse>(`${this.url + apiRoute}`, body, {
      headers: this.headers,
      withCredentials: true,
      ...options
    });
  }
  deleteFile(apiRoute: string, contentType) {
    return this.http.delete(`${apiRoute}`, {
      headers: this.getAttachmentHttpHeaders(contentType)
    });
  }
  getDownload(apiRoute: string, contentType) {
    return this.http.get(`${apiRoute}`, { responseType: 'blob' as 'json', headers: this.getAttachmentHttpHeaders(contentType) });
  }
  getDownload1(apiRoute: string, contentType?: string): Observable<Blob> {
  return this.http.get(`${this.url + apiRoute}`, {
    responseType: 'blob',
    headers: this.getAttachmentHttpHeaders(contentType)
  }) as Observable<Blob>; // ✅ clean cast
}

  postFormData(apiRoute: string, formData: FormData) {
  return this.http.post(this.url + apiRoute, formData, {
    withCredentials: true
  });
}


}
